import { useBudgetApi } from '@/api/Budget'
import { QueryClient, useQuery } from 'vue-query'
import { ref } from 'vue'
import QueryKeys from '@/vue-query/QueryKeys'

export function useBudgetsQuery({ enabled } = { enabled: ref(true) }) {
  const client = useBudgetApi()
  return useQuery({
    queryKey: [QueryKeys.Budget],
    queryFn: () => client.getBudgets(),
    enabled,
  })
}

export function useBudgetsQueryPrefetch(
  queryClient: QueryClient,
): Promise<void> {
  const client = useBudgetApi()
  return queryClient.prefetchQuery({
    queryKey: [QueryKeys.Budget],
    queryFn: () => client.getBudgets(),
  })
}
